module.exports = __webpack_public_path__ + "static/media/Maarseveen,Jane.355408a2.png";